import { Link } from "@reach/router";
import React from "react";

const Navbar = () => {
  const isActive = (link) => {
    return window.location.pathname.includes(link);
  };

  const activeLinkStyle = {
    color: "#0d6efd",
  };

  return (
    <nav
      className="navbar navbar-main navbar-expand-lg navbar-dark fixed-top mw-100 shadow-sm align-items-center"
      style={{ backgroundColor: "#27272b" }}
    >
      <div className="container-fluid navbar-container ps-0 ps-md-auto">
        <Link className="navbar-brand flex-shrink-0 py-2 px-2" to="/">
          <img
            src="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcerts-logo.png"
            className="logo-navbar"
            alt="logo"
          />{" "}
        </Link>
        <div className="d-flex d-lg-none align-items-center gap-2 ms-auto">
          <Link
            to="/entrar"
            className="btn btn-sm btn-accent bold round"
            style={{ padding: "0.375rem 0.65rem" }}
          >
            <i className="fa fa-user"></i>
          </Link>
          <button
            className="navbar-toggler position-static"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
        <div className="collapse navbar-collapse mw-100 flex-grow-1 min-w-0" id="navbarNav">
          <div className="container-fluid d-flex justify-content-between align-items-center">
            <ul className="navbar-nav nav">
              <li className={`nav-item ${isActive("about")}`}>
                {window.location.pathname !== "/" ? (
                  <a
                    href="#about-video"
                    className="nav-link"
                    to="/"
                  >
                    Conócenos
                  </a>
                ) : (
                  <a href="#about-video" className="nav-link" to="/">
                    Conócenos
                  </a>
                )}
              </li>
              <li className={`nav-item ${isActive("presencial")}`}>
                <Link
                  className="nav-link"
                  to="/live"
                  style={
                    isActive("live") ? activeLinkStyle : { color: "white" }
                  }
                >
                  En Vivo
                </Link>
              </li>
              <li className={`nav-item ${isActive("online")}`}>
                <Link
                  className="nav-link"
                  to="/ondemand"
                  style={
                    isActive("ondemand") ? activeLinkStyle : { color: "white" }
                  }
                >
                  On Demand
                </Link>
              </li>
              <li className={`nav-item ${isActive("tbmOnline")}`}>
                <a
                  className="nav-link"
                  href="https://thebodymethod.mx"
                  target="_blank" rel="noreferrer"
                >
                  TBM Online
                </a>
              </li>
              {/*<li className="nav-item">
                <a
                  className="nav-link"
                  target="_blank"
                  href="https://shop.thebodymethod.mx"
                >
                  Shop
                </a>
                </li>*/}
            </ul>
            <div className="d-none d-lg-block">
              <Link
                className="btn btn-sm btn-accent bold"
                to="/entrar"
              >
                <i className="fa fa-user me-1"></i> Ingresar
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
